import { useQuery } from "@tanstack/react-query";
import _ from "lodash";

import { customFetch } from "../util/customFetch";

export function useTemplateList({ enabled = true, params }) {
  const page = params.page || params.firstResult;
  const size = params.size || params.maxResults;
  const sortOrder = params.sortOrder || "desc";
  const sort = params.sortBy
    ? `${params.sortBy},${sortOrder}`
    : params.sort
      ? `${params.sort},${sortOrder}`
      : "";

  const queryParams = {
    ...params,
    page,
    size,
    sortOrder,
    sort,
  };
  return useQuery({
    enabled,
    queryKey: ["templates", params],
    queryFn: async () =>
      customFetch(
        `/api/smartbpm/documents/rest/{tenant}/templates?${new URLSearchParams(_.omitBy(queryParams, _.isNil))}`,
      ),
  });
}
